import { Box } from "@mui/system";
import { PropTypes } from "prop-types";

import UseWindowDimensions from "../../../../utils/windowSize";

export const AboutModalTab = (props) => {
  const { children, value, index, ...other } = props;
  const { height } = UseWindowDimensions();

  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      style={{
        width: "100%",
        overflowY: "scroll",
        height: `${height - 203}px`,
      }}
    >
      {value === index && <>{children}</>}
    </Box>
  );
};

AboutModalTab.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
